import {http} from "../http";

export interface ChangePassword{
    userName : string;
    oldPassword : string;
    newPassword : string;
    newPasswordRepeat : string;
}

export interface ChangePasswordVerify{
    userName : string;
    verfication : string;
}

export const updatePassword = async (request_data: ChangePassword): Promise<ChangePassword> => {
    const { data } = await http.post<ChangePassword>("auth/changepassword", request_data);
    return data;
};


export const changePasswordVerify = async (request_data: ChangePasswordVerify): Promise<ChangePassword> => {
    const { data } = await http.post<ChangePassword>("auth/changepassword/verify", request_data);
    return data;
};
